export function getWeekDateList(dutyWeeks, weekIndex) {
    if (!Array.isArray(dutyWeeks) || (Array.isArray(dutyWeeks) && dutyWeeks.length === 0))
        return []

    const date = new Date()
    let result = []
    dutyWeeks[weekIndex].days.forEach(day => {
        if (day.number_day)
            result.push(new Date(date.getFullYear(), date.getMonth(), day.number_day).toLocaleDateString())
        else
            result.push('')
    })
    return result
}

export function transformDuty(duty) {
    if (Object.keys(duty).length === 0 || (duty?.weeks && duty.weeks?.length && duty.weeks.length < 1))
        return

    const newDuty = {...duty}
    const rowsCount = duty.weeks[0].days[0].times.length

    for (let iweek = 0; iweek < duty.weeks.length; iweek++) {
        let rows = []
        for (let i = 0; i < rowsCount; i++)
            rows.push([])

        for (let iday = 0; iday < duty.weeks[iweek].days.length; iday++) {
            for (let itime = 0; itime < rowsCount; itime++) {
                if (duty.weeks[iweek].days[iday].number_day === 0)
                    rows[itime].push(null)
                else
                    rows[itime].push(duty.weeks[iweek].days[iday].times[itime])
            }
        }

        newDuty.weeks[iweek].rows = rows
    }

    console.log(newDuty)
    return newDuty
}

export function getCurrentWeek(duty) {
    if (!duty || Object.keys(duty).length === 0 || (duty?.weeks && duty.weeks?.length && duty.weeks.length < 1))
        return 0

    const currentDay = new Date().getDate()

    for (let iweek = 0; iweek < duty.weeks.length; iweek++) {
        console.log('week:', iweek)
        for (let iday = 0; iday < duty.weeks[iweek].days.length; iday++)
            if (duty.weeks[iweek].days[iday].number_day === currentDay)
                return iweek
    }

    return 0
}
